/*
  humble-home.js
  Humble Tire & Automotive — Homepage JavaScript
  Handles: Shopify AJAX cart, filter tabs, cart drawer, native Shopify checkout
*/

/* ── UTILITY ── */
function htFormatMoney(cents) {
  return '$' + (cents / 100).toFixed(0);
}

/* ── SHOPIFY AJAX CART ── */
async function htAddToCart(variantId, brand, name, price, condition) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    await htRefreshCartUI();
    htOpenCartDrawer();
  } catch (e) {
    alert('Could not add to cart. Please try again or call us at (281) 446-3443.');
  }
}

async function htGetCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function htChangeLineQty(line, delta) {
  const cart = await htGetCart();
  const item = cart.items[line];
  if (!item) return;
  const newQty = Math.max(0, item.quantity + delta);
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line + 1, quantity: newQty })
  });
  await htRefreshCartUI();
}

async function htRemoveLine(line) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line + 1, quantity: 0 })
  });
  await htRefreshCartUI();
}

/* ── CART UI ── */
function htTireSVG() {
  return `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" style="width:48px;height:48px;">
    <circle cx="50" cy="50" r="44" fill="#0d1f35" stroke="#1a3a5c" stroke-width="2"/>
    <circle cx="50" cy="50" r="32" fill="#1e1e1e" stroke="#2a2a2a" stroke-width="1.5"/>
    <circle cx="50" cy="50" r="16" fill="#0d1f35" stroke="#1a3a5c" stroke-width="1.5"/>
    <circle cx="50" cy="50" r="8" fill="#07111f"/>
    ${[0,60,120,180,240,300].map(a=>`<line x1="50" y1="34" x2="50" y2="20" stroke="#2a2a2a" stroke-width="3.5" transform="rotate(${a},50,50)"/>`).join('')}
  </svg>`;
}

async function htRefreshCartUI() {
  const cart = await htGetCart();
  const count = cart.item_count;

  // Update cart count badges
  document.querySelectorAll('.ht-cart-count').forEach(el => { el.textContent = count; });

  const itemsEl = document.getElementById('ht-cart-items');
  const footerEl = document.getElementById('ht-cart-footer');
  if (!itemsEl) return;

  if (!cart.items || cart.items.length === 0) {
    itemsEl.innerHTML = '<div class="ht-cart-empty">Your cart is empty.<br><span style="font-size:11.5px;">Browse tires above to get started.</span></div>';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  if (footerEl) footerEl.style.display = 'block';

  // Update total
  const totalEl = document.getElementById('ht-cart-total');
  if (totalEl) totalEl.textContent = htFormatMoney(cart.total_price);

  // Render items
  itemsEl.innerHTML = cart.items.map((item, i) => {
    const isUsed = item.variant_title && item.variant_title.toLowerCase().includes('used')
      || (item.properties && item.properties['Condition'] === 'Used')
      || false;
    const imgHTML = item.image
      ? `<img src="${item.image}" alt="${item.title}" style="width:100%;height:100%;object-fit:cover;">`
      : htTireSVG();

    return `
      <div class="ht-cart-item">
        <div class="ht-cart-item-img">${imgHTML}</div>
        <div class="ht-cart-item-info">
          <div class="ht-cart-item-brand">${item.vendor || ''}</div>
          <div class="ht-cart-item-name">${item.product_title}</div>
          <div class="ht-cart-item-cond">${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
          <div class="ht-cart-item-qty">
            <button class="ht-qty-btn" onclick="htChangeLineQty(${i}, -1)">&#8722;</button>
            <span class="ht-qty-val">${item.quantity}</span>
            <button class="ht-qty-btn" onclick="htChangeLineQty(${i}, 1)">&#43;</button>
          </div>
          <button class="ht-cart-remove" onclick="htRemoveLine(${i})">Remove</button>
        </div>
        <div class="ht-cart-item-price">${htFormatMoney(item.line_price)}</div>
      </div>`;
  }).join('');
}

/* ── CART DRAWER TOGGLE ── */
function htToggleCart() {
  const drawer = document.getElementById('ht-cart-drawer');
  const overlay = document.getElementById('ht-cart-overlay');
  if (!drawer) return;
  drawer.classList.toggle('open');
  overlay.classList.toggle('open');
}

function htOpenCartDrawer() {
  document.getElementById('ht-cart-drawer')?.classList.add('open');
  document.getElementById('ht-cart-overlay')?.classList.add('open');
}

function htCloseCartDrawer() {
  document.getElementById('ht-cart-drawer')?.classList.remove('open');
  document.getElementById('ht-cart-overlay')?.classList.remove('open');
}

/* ── FILTER TABS ── */
function htFilterTires(filter, btn) {
  document.querySelectorAll('.ht-shop-tab').forEach(t => t.classList.remove('active'));
  btn.classList.add('active');

  document.querySelectorAll('.ht-tire-card').forEach(card => {
    const condition = card.dataset.condition;
    const avail = card.dataset.avail;

    let show = true;
    if (filter === 'new' && condition !== 'new') show = false;
    if (filter === 'used' && condition !== 'used') show = false;
    if (filter === 'instock' && avail !== 'in-stock' && avail !== 'low-stock') show = false;

    card.classList.toggle('ht-hidden', !show);
  });
}

/* ── NATIVE SHOPIFY CHECKOUT ── */
async function htProceedToCheckout() {
  // Save the vehicle/notes field as a cart note so it appears on the Shopify order
  const note = document.getElementById('ht-cart-vehicle-note')?.value.trim() || '';
  if (note) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    });
  }
  // Send customer to Shopify's native checkout
  window.location.href = '/checkout';
}

/* ── MOBILE NAV ── */
function htToggleMobileNav() {
  document.getElementById('ht-mobile-nav')?.classList.toggle('open');
}

function htCloseMobileNav() {
  document.getElementById('ht-mobile-nav')?.classList.remove('open');
}

/* ── SMOOTH SCROLL + SHOP OPEN ── */
function htOpenShop() {
  const shopEl = document.getElementById('ht-shop');
  if (shopEl) shopEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  htCloseMobileNav();
}

/* ── SCROLL REVEAL ── */
function htInitScrollReveal() {
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('in'); });
  }, { threshold: 0.07, rootMargin: '0px 0px -20px 0px' });
  document.querySelectorAll('.ht-rv').forEach(el => io.observe(el));
}

/* ── SMOOTH ANCHOR LINKS ── */
function htInitSmoothAnchors() {
  document.querySelectorAll('#ht-homepage a[href^="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const target = a.getAttribute('href');
      const el = document.querySelector(target);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        htCloseMobileNav();
      }
    });
  });
}

/* ── INIT ── */
document.addEventListener('DOMContentLoaded', function () {
  htRefreshCartUI();
  htInitScrollReveal();
  htInitSmoothAnchors();
});
